<template>
<div class="detail-content mgt-12">
<div class="">
<div class="position-relative">
<!-- <div class="dashed-line-vertical" style="left:30%"></div> -->
<div class="percentage-wrapper pdt-7">
    <div class="d-flex justify-content-between align-items-center">
        <div class="t-color-lecturePurple t-helper font-r">{{$t('25')}}</div>
        <div class="d-flex align-items-baseline">
            <div class="percent-number t-color-lecturePurple t-subtitle1 l-spacing6 font-b mgr-4 ">
                {{`${score}`}}
            </div>
            <div class="t-color-lecturePurple t-helper font-r">{{$t('27', {str: ''})}}</div>
        </div>
    </div>
    <div
        class="h-2 position-relative total-percentage mgt-1 mgb-20 bg-iconinactiveText">
        <div class="real-percentage bg-lecturePurple h-6 " :style="`width:${score}%;`">
        </div>
    </div>
</div>
<div class="percentage-wrapper">
    <div class="d-flex justify-content-between align-items-center">
        <div class="t-color-iconInactive t-helper font-r"> {{$t('26')}}</div>
        <div class="d-flex align-items-baseline">
            <div class="percent-number t-color-iconInactive t-subtitle2 l-spacing6 font-b mgr-4 ">
                {{`${averageScore}`}}
            </div>
            <div class="t-helper t-color-iconInactive font-r">{{$t('27', {str: ''})}}</div>
        </div>
    </div>
    <div
        class="h-2 position-relative total-percentage mgt-5 bg-iconinactiveText">
        <div class="real-percentage bg-iconInactive h-6" :style="`width:${averageScore}%;`">
        </div>
    </div>
</div>
</div>
</div>
</div>
</template>

<script>
/**
 * 단독 시험 결과 리스트 결과 그래프 컴포넌트(independent exam result list graph component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
export default {
    props: ['examineeId', 'paperId'],
    data() {
        return {
            scoreData: null,
            averageScore: 0,
            standard: 0,
            score: 0
        }
    },
    mounted() {
        let params = {
            examineeId: this.examineeId
            
        }

        // 시험 결과 그래프 데이터(get exam result graph data)
        examApi.score(params).then((response) => {
            this.scoreData = response.data.data
            this.averageScore = parseInt(this.scoreData.averageScore)
            this.standard = parseInt(this.scoreData.standard)
            this.score = parseInt(this.scoreData.score)

        }).catch((err) => {
            
        })
    }

}
</script>

<style scoped>

 
  .total-percentage{
      background-color: rgba(172, 180, 190, 0.3);
  }
  .opacity7{
      opacity: 0.7;
  }
  .total-percentage .real-percentage{
      position: absolute;
      left: 0;
      top:-3px;
      border-radius:6px;
      width: 237px;
  }
  html[dir="rtl"] .total-percentage .real-percentage{
      right: 0;
  }
  .standard-percentage{
      color: var(--Iconinactive);
  }
  .standard-percentage:after {
    content: '';
    position: absolute;
    width: 0;
    height: 68px;
    border: dashed var(--Divider);
    border-width: 0.2px;
    bottom: 20px;
    left: 50%;
  }
  html[dir="rtl"] .standard-percentage:after {
    right: 50%;
  }

  .standard-percentage-wrap{position: relative;width: 100%;padding-bottom: 20px;}
  .standard-percentage-wrap .standard-percentage{
        left: 0%; 
        width:90px;
        position: absolute !important;
    }
    html[dir="rtl"] .standard-percentage-wrap .standard-percentage{
        right: 0%; 
    }
    .dotted-line{
        content: '';
        position: absolute;
        width: 0;
        height: 68px;
        border: dashed var(--Divider);
        border-width: 0.2px;
        bottom: 20px;
        left: 50%;
    }
    html[dir="rtl"] .dotted-line{
        right: 50%;
    }
  
</style>